import PropTypes from "prop-types";

export const STYLES = {
  pipe: "tw-border-r tw-border-l-0 tw-border-t-0 tw-border-b-0 tw-border-solid tw-border-gray-10 tw-h-[16px]",
  row: "tw-text-14d tw-flex tw-gap-8px",
  contentContainer: "tw-flex tw-flex-col tw-gap-4px tw-pl-12px",
  contentContainer2: "tw-flex tw-gap-20px tw-justify-between",
  textThemed: (isPlace) => (isPlace ? "tw-text-semantic-blue-100" : "tw-text-teal"),
  bgThemed: (isPlace) => (isPlace ? "tw-bg-semantic-blue-100" : "tw-bg-teal"),
  badgeThemed: (isPlace) =>
    isPlace ? "tw-bg-[#E6EDFA] tw-text-[#2454B2]" : "tw-bg-[#EEF9F9] tw-text-brand-success",
  lineClamp3: "tw-overflow-hidden tw-text-ellipsis tw-break-words tw-line-clamp-3 tw-text-gray-75",
  // Hidding until we have proper data (call, lisitng and report links)
  btnContainer: "tw-flex tw-gap-8px tw-mt-12px",
  btn: "tw-flex tw-items-center tw-gap-4px",
};

export const activityCommonPropTypes = {
  activity: PropTypes.shape().isRequired,
  Icon: PropTypes.func,
  children: PropTypes.node,
  childContainerClass: PropTypes.string,
  onReadChange: PropTypes.func,
  SideContent: PropTypes.node,
};

export const activityCommonDefaultProps = {
  onReadChange: () => {},
  childContainerClass: "",
  SideContent: null,
  queryParams: "",
};

export const includeFeatureFlaggedKeys = (featureFlag, activities) => (featureFlag ? activities : {});
